import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['replayFilters'];

  connect() {
    this.replayFiltersTargets.forEach((button) => {
      button.addEventListener('click', () => {
        this.replayFiltersTargets.forEach((btn) => {
          btn.classList.remove('active');
        });

        button.classList.add('active');
      });
    });
  }
}
